/**
 * One line per test a person has finished, for the admin person card.
 *
 * The server returns every finished sitting (exam_results, newest first);
 * the card wants one row per test: best score, how many times, when last.
 * The app has no pass mark — a finished test counts as "passed", the same
 * way a finished lesson does — so the score is shown for him to judge.
 */

export interface AdminExamSitting {
  test_number: number;
  score: number;
  finished_at: string;
}

export interface AdminExamSummary {
  test: number;
  best: number;
  tries: number;
  lastAt: string;
}

/** Points in a full test (EXAM.md: 8 + 8 + 8 + 12 + 12 + 6). */
export const EXAM_MAX_SCORE = 54;

/** Sorted by test number, so test 1 is always on top. */
export function summarizeExams(sittings: AdminExamSitting[]): AdminExamSummary[] {
  const byTest = new Map<number, AdminExamSummary>();
  for (const s of sittings) {
    const row = byTest.get(s.test_number);
    if (!row) {
      byTest.set(s.test_number, {
        test: s.test_number,
        best: s.score,
        tries: 1,
        lastAt: s.finished_at,
      });
      continue;
    }
    row.best = Math.max(row.best, s.score);
    row.tries += 1;
    if (Date.parse(s.finished_at) > Date.parse(row.lastAt)) row.lastAt = s.finished_at;
  }
  return [...byTest.values()].sort((a, b) => a.test - b.test);
}
